var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersNoQuoteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 80,
    viewBox: "0 0 78 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0752 23.0419V57.4438C2.0752 69.0876 19.1039 78.5295 39.7701 78.5295C60.4401 78.5295 77.4669 69.0876 77.4669 57.4438V23.0419H2.0752Z",
    fill: "#CAD4E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.442 22.3676C77.442 34.0971 60.5692 43.6076 39.7547 43.6076C18.9382 43.6076 2.06543 34.0971 2.06543 22.3676C2.06543 10.64 18.9382 1.13141 39.7547 1.13141C60.5692 1.13141 77.442 10.64 77.442 22.3676Z",
    fill: "#E0E8F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2706 21.6666C59.2706 27.7371 50.5403 32.6571 39.7706 32.6571C29.0028 32.6571 20.2725 27.7371 20.2725 21.6666C20.2725 15.5999 29.0028 10.6799 39.7706 10.6799C50.5403 10.6799 59.2706 15.5999 59.2706 21.6666Z",
    fill: "#ADBDD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2229 17.7352H46.9533C45.2202 16.581 42.6633 15.8343 39.7697 15.8343C36.8799 15.8343 34.323 16.581 32.5899 17.7352H30.3203V21.1581C30.3203 24.0991 34.5513 26.4857 39.7697 26.4857C44.99 26.4857 49.2229 24.0991 49.2229 21.1581V17.7352Z",
    fill: "#272826"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2229 17.7353C49.2229 20.6762 44.99 23.061 39.7697 23.061C34.5513 23.061 30.3203 20.6762 30.3203 17.7353C30.3203 14.7924 34.5513 12.4095 39.7697 12.4095C44.99 12.4095 49.2229 14.7924 49.2229 17.7353Z",
    fill: "#424240"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7035 17.7352C47.7035 20.2419 44.0984 22.2743 39.6467 22.2743C35.1969 22.2743 31.5898 20.2419 31.5898 17.7352C31.5898 15.2267 35.1969 13.1943 39.6467 13.1943C44.0984 13.1943 47.7035 15.2267 47.7035 17.7352Z",
    fill: "#272826"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4441 50.7505C57.6321 68.32 12.8068 59.9772 2.07514 33.501L2.07324 34.8915C5.72402 47.7295 21.364 57.5581 34.839 60.3867C48.6145 63.28 71.9669 60.8115 77.4441 50.7505Z",
    fill: "#99B0D0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4425 29.5428C74.2826 45.3219 55.224 56.0057 43.7998 58.1181C59.2077 57.2914 78.6449 43.6076 77.4425 29.5428Z",
    fill: "#99B0D0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.743 63.2286C10.9577 61.8115 7.48386 58.861 2.07522 56.5257C1.79557 56.4038 1.83742 57.261 2.07522 57.4438C11.3762 64.6267 27.6269 68.2515 44.901 60.8305C35.016 63.1695 23.2437 64.8229 16.743 63.2286Z",
    fill: "#99B0D0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersNoQuoteLogo);
export default __webpack_public_path__ + "static/media/ordersNoQuoteLogo.7bf35e14e2b029b2fc97340a24b57044.svg";
export { ForwardRef as ReactComponent };